const accidentFlows = {
  HOUSEHOLD: 'household',
  OCCUPATIONAL: 'occupational',
  ON_THE_WAY: 'onTheWay',
  OTHER: 'other',
};

export default accidentFlows;
